import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appAccordion]'
})
export class AccordionDirective {
  @HostListener('click', ['$event'])
  onToggleClick(event: Event) {
    const button = this.el.nativeElement as HTMLElement;
    const targetId = button.getAttribute('aria-controls');
    const target = targetId ? document.getElementById(targetId) : null;

    if (!target) return;

    const isOpen = target.classList.contains('show');

    // Toggle panel
    this.togglePanel(target, button, !isOpen);
  }

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  private togglePanel(panel: HTMLElement, button: HTMLElement, open: boolean) {
    if (open) {
      this.renderer.addClass(panel, 'show');
      this.renderer.removeClass(button, 'collapsed');
    } else {
      this.renderer.removeClass(panel, 'show');
      this.renderer.addClass(button, 'collapsed');
    }
    this.renderer.setAttribute(button, 'aria-expanded', String(open));
  }
}
